var window=global;var $CLJS=require("./cljs_env");require("./cljs_env.js");
'use strict';$CLJS.yC=require("ttag");module.exports=$CLJS.yC;